import { render, staticRenderFns } from "./genOrg.vue?vue&type=template&id=fcb8f1d6&scoped=true&"
import script from "./genOrg.vue?vue&type=script&lang=js&"
export * from "./genOrg.vue?vue&type=script&lang=js&"
import style0 from "./genOrg.vue?vue&type=style&index=0&id=fcb8f1d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb8f1d6",
  null
  
)

export default component.exports